export const BORDER_WIDTH = 4;
export const BORDER_PADDING = 16;
export const MAX_WIDTH = 500;
export const MAX_HEIGHT = 500;

export const COLOR_WHITE='#FFFFFF'